import {
  URL_LOGO,
} from '../Action-type/Index';

export function setUrlLogo(url) {
  return {
    type: URL_LOGO,
    payload: url
  }
}